import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData } from './utils';
const selectableData = getData().map(i => {
    i.selected = false;
    return i;
});
let DemoSingleAction = class DemoSingleAction extends LitElement {
    constructor() {
        super(...arguments);
        this.data = selectableData;
        this.selectedEntry = null;
        this.selectedEntryId = null;
    }
    render() {
        var _a, _b;
        return html `
      <cds-grid>
        <cds-grid-column width="42"></cds-grid-column>
        <cds-grid-column>Stock</cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row .select=${entry.selected}>
            <cds-grid-cell action>
              <cds-inline-button id="${entry.id}-action" @click=${() => this.select(entry)} aria-label="choose available stock options">
                <cds-icon shape="ellipsis-vertical"></cds-icon>
              </cds-inline-button>
            </cds-grid-cell>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
      <cds-dropdown ?hidden=${!this.selectedEntry} anchor="#${this.selectedEntryId}-action" @hiddenChange=${() => this.selectedEntry = null}>
        <cds-button @click=${() => this.buy(this.selectedEntry)} block action="flat" size="sm">Buy ${(_a = this.selectedEntry) === null || _a === void 0 ? void 0 : _a.id}</cds-button>
        <cds-button @click=${() => this.sell(this.selectedEntry)} block action="flat" size="sm">Sell ${(_b = this.selectedEntry) === null || _b === void 0 ? void 0 : _b.id}</cds-button>
      </cds-dropdown>
    `;
    }
    select(entry) {
        this.selectedEntry = entry;
        this.selectedEntryId = entry.id;
    }
    buy(entry) {
        alert(`Bought: ${entry.id}`);
        this.selectedEntry = null;
    }
    sell(entry) {
        alert(`Sold: ${entry.id}`);
        this.selectedEntry = null;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoSingleAction.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoSingleAction.prototype, "selectedEntry", void 0);
__decorate([
    internalProperty()
], DemoSingleAction.prototype, "selectedEntryId", void 0);
DemoSingleAction = __decorate([
    customElement('demo-single-action')
], DemoSingleAction);
export { DemoSingleAction };
//# sourceMappingURL=demo.row-single-action.js.map